module.exports = __webpack_public_path__ + "static/media/plakat_aktion.10daa115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/plakat_aktion.png
// module id = 496
// module chunks = 0